import type { Tokens } from '../../../../theming/types'
import type { BaseMenuItemProps } from '..'

export default (config: {
  props: Pick<
    BaseMenuItemProps,
    'active' | 'disabled' | 'hasStartElementIcon' | 'selected' | 'startElement'
  >
  tokens: Tokens
}) => {
  const { props, tokens } = config

  function getBackgroundStyle() {
    if (props.selected) {
      return tokens.itemBgColorSelected
    }
    if (props.active) {
      return tokens.itemBgColorHover
    }
    return 'transparent'
  }
  function getColorStyle() {
    if (props.disabled) {
      return tokens.fontColorDisabled
    }
    if (props.active) {
      return 'inherit'
    }
    return tokens.fontColorDefault
  }

  return {
    default: {
      content: {
        ...tokens.fontBodyM,
        background: getBackgroundStyle(),
        borderRadius: 0,
        color: getColorStyle(),
        padding: '4px 16px 4px 16px',
        minHeight: '30px',
        width: '100%',

        ...(!props.disabled && {
          '&:hover': {
            background: tokens.itemBgColorHover,
          },

          '&:active': {
            background: tokens.itemBgColorActive,
          },
        }),
      },

      startElement: {
        marginInlineEnd: '12px',
        color: props.disabled
          ? tokens.iconColorDisabled
          : tokens.iconColorDefault,
      },

      endElement: {
        color: props.disabled
          ? tokens.iconColorDisabled
          : tokens.iconColorDefault,
      },

      text: {
        // This originates in Menu.Group. It checks to see if the Menu.Group contains startElementIcons.
        marginInlineStart:
          props.hasStartElementIcon && !props.startElement ? '28px' : undefined,
      },

      badge: {
        top: '-7px',
      },
    },

    selectedOption: {
      iconWrap: {
        marginInlineEnd: '8px',
      },
    },
  } as const
}
